<template>
  <el-row
    :gutter="24"
    style="
      background-color: #059bf9;
      color: #fff;
      line-height: 35px;
      position: fixed;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 99;
      margin: 0 !important;
    "
  >
    <el-col :span="5">
      <i v-if="!hideBack" class="el-icon-arrow-left" @click="backPage()"
        >返回</i
      >
    </el-col>
    <el-col :span="hideBack ? 17 : 10" :offset="hideBack ? 1 : 3">
      <div
        class="grid-content bg-purple"
        :style="{ textAlign: hideBack ? 'left' : 'center' }"
      >
        {{ title }}
      </div>
    </el-col>
    <el-col :span="6"
      ><div class="grid-content bg-purple">
        <i class="el-icon-user" @click="logout()">{{ login_name }}</i>
      </div></el-col
    >
  </el-row>
</template>
<script>
export default {
  name: "header",
  props: {
    title: String,
    hideBack: Boolean,
  },
  data() {
    return {
      login_name: "",
    };
  },
  mounted() {
    this.login_name = JSON.parse(localStorage.getItem("uinfo")).name;
  },
  methods: {
    backPage() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 500);
    },
    async logout() {
      await this.$api.confirm("确定退出登录吗？");
      localStorage.removeItem("uid");
      this.$router.replace("/login");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
